import type { AxiosInstance } from "axios";

let integrationIntakeBaseUrl: string | null = null;

const INTAKE_INTEGRATION_PATH_PREFIXES = [
  "/api/file-uploads",
] as const;

export function setIntegrationIntakeBaseUrl(url: string | null) {
  integrationIntakeBaseUrl = url && url.trim().length > 0 ? normalizeBaseUrl(url.trim()) : null;
}

export function getIntegrationIntakeBaseUrl(): string | null {
  return integrationIntakeBaseUrl;
}

function normalizeBaseUrl(url: string): string {
  return url.replace(/\/+$/, "");
}

function requestPath(url: string): string {
  if (!url.startsWith("http")) {
    return url;
  }
  try {
    return new URL(url).pathname;
  } catch {
    return url;
  }
}

function shouldRouteToIntakeHost(url: string): boolean {
  const path = requestPath(url);
  return INTAKE_INTEGRATION_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function attachIntakeIntegrationRequestInterceptor(client: AxiosInstance) {
  client.interceptors.request.use((config) => {
    const url = config.url ?? "";
    if (!url || !shouldRouteToIntakeHost(url)) {
      return config;
    }
    const base = getIntegrationIntakeBaseUrl();
    if (base) {
      config.baseURL = base;
    }
    return config;
  });
}
